'use client'
import { useEffect, useState } from 'react'
import Image from 'next/image'
import banner1 from '@public/image/login-banner1.jpg'
import banner2 from '@public/image/login-banner2.jpg'
import banner3 from '@public/image/login-banner3.jpg'
import banner4 from '@public/image/login-banner4.jpg'
import { TBaseComponentProps } from '@segway/core'

import { Header } from '@/components/header'

const imgList = [banner1.src, banner2.src, banner3.src, banner4.src]

/**
 * 默认 Layout
 */

const MainLayout = (props: TBaseComponentProps) => {
  const [currentIndex, setCurrentIndex] = useState(0)

  useEffect(() => {
    if (typeof window === 'undefined') return

    imgList.forEach((url) => {
      const link = document.createElement('link')
      link.rel = 'preload'
      link.as = 'image'
      link.href = url
      document.head.appendChild(link)
    })
  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex === imgList.length - 1 ? 0 : prevIndex + 1))
    }, 5000)

    return () => clearInterval(interval)
  }, [])

  return (
    <div className="flex h-screen flex-col">
      <div>
        <Header />
      </div>
      <div className="relative flex-1 overflow-auto">
        <div className="left-0 top-0 z-10 hidden h-full w-full overflow-hidden xl:block">
          <div className="relative h-full w-full overflow-hidden">
            {imgList.map((image, index) => (
              <div
                key={index}
                className={`absolute inset-0 transition-opacity ease-in-out ${
                  index === currentIndex ? 'opacity-100' : 'opacity-0'
                }`}
                style={{ transitionDuration: '2000ms' }}>
                <Image
                  src={image}
                  alt={image}
                  className="h-full w-full object-cover"
                  style={{ objectPosition: 'center' }}
                  width={1920}
                  height={1080}
                  priority={index === 0}
                />
              </div>
            ))}
          </div>
        </div>
        <div className="absolute left-0 top-0 h-full w-full">{props.children}</div>
      </div>
    </div>
  )
}

export default MainLayout
